import React, { useContext, useEffect, useMemo } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import FormWrapper from '../../../../../Components/Form/FormWrapper';
import {
	ContextDataProps,
	FieldNames,
	HealthPlanContext,
} from '../../../../../Services/HealthBabyPlanDataContext';
import useTranslation from '../../../../../Hooks/useTranslation';
import SubmitButton from '../../../../../Components/Button/SubmitButton';
import useAdditionalWeightInPregnancy from '../hooks/useAdditionalWeightInPregnancy';
import MothersHealthFields, {
	getMothersHealthFieldsValidationSchema,
} from '../FieldsForms/MothersHealthFields';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import { getMomentDate } from '../../../../../Utils/dates.util';
import { FieldValues } from 'react-hook-form';
import { getTimeWithTimezoneOfSpecificDateAsString } from '../../../../Base/Helpers/timezone.helper';

interface Props {
	onSuccess: () => void;
	patientId: string;
}

const MothersHealthForm: React.FC<Props> = ({ onSuccess, patientId }) => {
	const { t } = useTranslation();
	const { data, setData } = useContext(HealthPlanContext);

	const defaultValues = {
		[FieldNames.MOTHERS_HEALTH]: data[FieldNames.MOTHERS_HEALTH],
	};

	const formMethods = useForm({
		defaultValues: defaultValues,
		resolver: yupResolver(getMothersHealthFieldsValidationSchema(t, true)),
	});

	const values = formMethods.watch(FieldNames.MOTHERS_HEALTH);

	const { additionalWeightInPregnancy } = useAdditionalWeightInPregnancy({
		//@ts-ignore
		weighBeforePregnancy: values?.weighBeforePregnancy,
		//@ts-ignore
		actualWeight: values?.actualWeight,
	});

	const handleSubmitForm = (fields: FieldValues) => {
		fields.mothersHealth.timeOfExamination =
			getTimeWithTimezoneOfSpecificDateAsString({
				time: getMomentDate(fields.mothersHealth.timeOfExamination),
				date: getMomentDate(fields.mothersHealth.dateOfExamination),
			});

		const finalFields = {
			...fields,
			[FieldNames.MOTHERS_HEALTH]: {
				//@ts-ignore
				...fields[FieldNames.MOTHERS_HEALTH],
				additionalWeightInPregnancy,
			},
		};

		setData(finalFields);
		onSuccess();
	};

	/*useEffect(() => {
		//@ts-ignore
		if (values?.edemas?.length >= 2 && values.edemas?.[0].value === 'absent') {
			formMethods.setValue(
				//@ts-ignore
				`${FieldNames.MOTHERS_HEALTH}.edemas`,
				//@ts-ignore
				values.edemas.filter(({ value }) => value !== 'absent'),
			);
		}

		if (
			//@ts-ignore
			values?.edemas?.length > 1 &&
			//@ts-ignore
			values?.edemas?.pop().value === 'absent'
		) {
			//@ts-ignore
			formMethods.setValue(`${FieldNames.MOTHERS_HEALTH}.edemas`, [
				{
					value: 'absent',
					label: t('base.absent'),
				},
			]);
		}
	}, [
		JSON.stringify(
			//@ts-ignore
			values?.edemas,
		),
	]);*/

	return (
		<ScrollContainer>
			<div className='col-12 '>
				<div className='page-panel mt-1'>
					<FormWrapper formMethods={formMethods}>
						<MothersHealthFields
							isEntryQuestionnaire
							additionalPregnancyWeight={additionalWeightInPregnancy}
							formMethods={formMethods}
						/>
						<div className='d-flex mt-4 justify-content-between'>
							<SubmitButton
								title={'base.shared.continue'}
								onSubmit={handleSubmitForm}
							/>
						</div>
					</FormWrapper>
				</div>
			</div>
		</ScrollContainer>
	);
};

export default MothersHealthForm;
